export default {
  app_name: import.meta.env.VITE_APP_SITE_NAME,
  shopping_agent: 'Shopping Agent',
  forwarding: 'Forwarding',
  services: 'Services',
  about: 'About',
  expert_buy: 'Expert Buy',
  shipping_calculator: 'Shipping Calculator',
  customer_review: 'Customer Review',
  dropshipping: 'Dropshipping',
  business_service: 'Business Service',
  trusted_seller: 'Trusted Seller',
  blog: 'Blog',
  user_guides: 'User Guides',
  terms_of_service: 'Terms of Service',
  terms_of_shipping: 'Terms of Shipping',
  privacy_policy: 'Privacy Policy',
  faq: 'FAQ',
  home: 'Home',
  notice: 'Notice',
  cart: 'Cart',
  me: 'Me',
  service_menu: 'Services Menu',
  account: 'Account',
  user_center: 'User Center',
  my_order: 'My Order',
  my_store: 'My Store',
  log_out: 'Logout',
  sign_in: 'Sign in',
  sign_up: 'Sign Up',
  compensation_taxation: 'Compensation and Taxation',
  tok_forum: 'Forum',
  get_community_help: 'Join our forum',
  community_des: 'Join our forum to help and get helped',
  header: {
    search: {
      text: "Product URL",
      button: "Search"
    },
    shipping_estimation: "Shipping Estimation",
    guide: "Beginer's Guide",
    findandbuy: "FindAndBuy",
    affiliation: "Affiliation",
    contact: "Contact",
    cart: "Cart",
    sign_in: "Sign in",
  },
  page_home: {
    title: 'Your Ultimate',
    description: 'Chinese Shopping Agent',
    search_product_text: 'Product URL',
    timeline: [
      {
        title: "Place Orders",
        subtitle: "Selection and Purchase"
      },
      {
        title: "Submit Parcels",
        subtitle: "QC Confirm and Global Shipping"
      },
      {
        title: "Sign Delivery",
        subtitle: "Receive and Share"
      }
    ],
    cards: [["Sign up", "and get 350$ coupon!"],
    ["Beginner's", "Guide"],
    ["Join us", "on Reddit&Discord"]
    ],
    shop_chinese: {
      title: "Shop From Chinese E-Commerce Sites",
      cards: [
        {
          "title": "Placing Your Orders",
          "description": "Experience hassle-free shopping for any product from China, available both online and offline. To place your order, simply paste the link of the product. Enjoy our seamless, end-to-end service that takes you from browsing to buying with ease."
        },
        {
          "title": "Delivery to NiuniuBox Warehouse",
          "description": "Shop from a variety of sellers through our service, and we’ll efficiently consolidate your purchases. All items will be shipped to the NiuniuBox warehouse in China, streamlining the process for your convenience."
        },
        {
          "title": "Quality Check",
          "description": "Once your products arrive at the NiuniuBox warehouse, they are subjected to a thorough Quality Check. Our team meticulously examines each item for any defects, ensuring accuracy in size, color, and more. With NiuniuBox, you can enjoy peace of mind, knowing that our dedicated after-sales service is committed to your satisfaction."
        },
        {
          "title": "Global Shipping",
          "description": "Select products from your warehouse inventory and consolidate them effortlessly into one parcel. With NiuniuBox’s reliable global shipping services, you can have your purchases delivered straight to your doorstep. Enjoy the convenience of world-class shipping at your fingertips."
        }
      ]

    },
    bottom: [
      {
        "title": "Massive Products",
        "description": "Finding diverse and cost-efficient products for you from China"
      },
      {
        "title": "Lower Cost",
        "description": "One-time shipping cost for products from different sellers, getting all your purchase in just one parcel"
      },
      {
        "title": "Quality Service",
        "description": "We value your business and aim to provide exceptional service and support"
      },
      {
        "title": "Prompt Response",
        "description": "Guaranteed response and solution to any of your questions regarding our service"
      }
    ],
    migration: {
      title: "Important announcement",
      dear_users: "Dear Users,",
      announce_before_link:
        "We are pleased to announce that Niuniubox has officially been renamed to Pikobuy ",
      link_label: "www.pikobuy.com",
      closing:
        "We will continue to provide you with our dedicated service under our new brand name.",
      got_it: "Got it",
    },

  },
  page_shopping: {
    shopping_des: 'Shop from China',
    shopping_step: '1.Find & Search Product  2.Pay for items  3.Buy for you  4.Pay for shipping  5.Ship for you',
    category: 'Category',
    load_more_items: 'Load more items',
    note: 'Disclaimer: All products available for shopping agent service displayed on our site are from third-party shopping platforms and not directly sold by us. Thus, We do not take liability and legal responsibility for issues caused by intellectual property rights infringement and goods copyright infringement.',
    bottom_text: 'As a professional Taobao agent, we help you to buy a lot of products at super low prices from China\'s largest shopping sites. We are your Taobao agent to find, buy, inspect and deliver items from Taobao.com,1688.com. Our quotation includes sourcing from China, purchasing and international shipping. We provide the biggest discounts for international shipping from China to all countries, including the US, Canada, UK, Australia, France, Singapore, Mexico, Brazil, Chile, and more. Wherever you are, we deliver parcels directly to your door. We provide online tracking information for all shipments. We have professional customer service managers to help you shop and ship successfully.',
    process_data: 'Process Data',
    process_des: 'You can know everything about your order. Every time you care about, we have data to tell you everything.',
  },
  page_forwarding: {
    title: 'International Freight Forwarding',
    des: 'Ship your parcel from China',
    forwarding_step: '1.Buy yourself 2.Ship to warehouse 3.Quality Inspection 4.Pay for shipping 5.Ship to you',
    country_name: 'Destination Country',
    product_name: 'Product Name',
    tracking_number: 'Tracking Number',
    tracking_number_des: 'Taobao/1688/Weidian tracking number',
    product_limit: 'Product Picture(Limit 1M)',
    submit_text: 'Submit Parcel',
    submit_note: 'Remember to ship your parcel to our warehous; We will no longer support #sea freight# services;',
    how_to_use: 'How to use?',
    service_line1: '1. You need to buy from Taobao/1688/JD/Weidian and ship to our warehouse.',
    service_line2: '2. You need to submit a Forwarding Order on this page once you have the parcel tracking number.',
    service_line3: '3. Waiting for your parcel to arrive at our warehouse.We will identify your package based on the tracking number.',
    service_line4: '4. We will let you know by mail if the parcel arrives at the warehouse.',
    service_line5: '5. You need to submit to ship and pay the international shipping fee.',
    service_line6: '6. We ship the parcel to you.',
    cost_note: 'For an estimate of international shipping costs before placing your shipping order, you may use our',
    view_forwarding: 'View Forwarding Order',
    warehouse_address: 'Warehouse Address',
    item_category: 'Product Category',
    warehouse_phone: 'Phone',
    warehouse_contact_name: 'Contact Name',
    warehouse_province: 'Province',
    warehouse_city: 'City',
    warehouse_district: 'District',
    warehouse_street: 'Street',
    warehouse_detail: 'Building',
    warehouse_postcode: 'Zip code',
    service_name: 'Freight Forwarding Service',
    service_des: 'Our Freight Forwarding service is one of the main services that we provide for you here. Whether you are buying from a major E-Commerce website like Taobao, or you already have products in China which you wish to ship, We have got you covered.By partnering with logistics companies with over 40 years of experience in the industry, such as FedEx, DHL, UPS, etc., We aim to provide efficient and quality freight forwarding at an affordable price.Wherever you may be in the World, We will find a way to get your package safely to your doorstep, giving you a peace of mind when you are shipping with us.',
  },
  page_expert: {
    des: 'Can not find product? Help global users buy from Taobao/Weidian/1688/Yupoo',
    past_product_name: 'Paste product name here',
    product_url: 'Product Url',
    unit_price: 'Unit Price',
    past_unit_price: 'Paste product price here',
    quality: 'Quality',
    delivery_fee: 'Delivery Fee',
    delivery_fee_note: 'Local Delivery Fee. If not sure, fill 0 in the blank',
    product_remark: 'Product Remarks',
    product_remark_note: 'Product size, color, version...',
    add_to_cart: 'Add to cart',
    step_line1: '1. Find your product from Taobao/1688/Weidian/Tmall or other platforms.',
    step_line2: '2. Copy the product information and add to cart.',
    step_line3: '3. Visit your shopping cart to make payment for your product.',
    step_line4: '4. We purchase for you and wait for the parcel to arrive at our warehouse.',
    step_line5: '5. Submit address and pay shipping fee after parcel arrives at our warehouse.',
    about_expert_buy: 'About Expert Buy',
    about_des: 'Our Expert Buy feature is part of the shopping agent services that we provide for you. You can use our Expert Buy feature if our Shopping Agent page is unable to fetch data on your products via your product URL link. It supports product URL links from all major Chinese E-Commerce websites, such as Taobao, 1688, TMall, Weidian and many more. If you can find it, we can buy and ship it for you, wherever you may be in the World! Find out more about how to use our Expert Buy feature using our Shopping Agent Guide.',
    product_shipping_note: 'International shipping fee is not included,it will be calculated and charged after gooods arriving our warhouse',
    product_detail_remark: 'Product size, color, version, style, quantity. If you are not sure about the description of the above products, please add a note here so that we can purchase the correct product for you.',
    expert_btn: 'If unable to add to cart, click the button # Expert Buy #',
    product_show_price: 'Price',
    product_show_quantity: 'Product Quantity',
    product_show_shipping: 'Local Shipping',
  },
  page_calculator: {
    des: 'Calculate the global shipping price',
    item_category: 'Product Category',
    product_weight: 'Weight',
    product_length: 'Length',
    product_width: 'Width',
    product_height: 'Height',
    check: 'Check Now',
    cost_note: 'Note: The parcel weight should not be less than 2.5KG for UPS/DHL/FedEx. Otherwise only can ship by Small Parcel Line',
    about_service: 'Our Shipping Calculator is a complementary feature that we offer on our website as part of our shopping agent and freight forwarding services. Using our shipping calculator, you can estimate the approximate shipping fee that you would need to pay given the dimensions of your products or package, and your destination country. You can also use our shipping calculator to check up on the different shipping companies available to ship to your destination country, as well as their respective estimate shipping times.',
    service_title: 'About Calculator',
    common_goods: 'Ordinary Goods',
    brand_goods: 'Branded goods',
    liquid_goods: 'Liquid goods',
    battery_goods: 'Battery goods',
    shipping_method: 'Shipping Method',
    delivery_time: 'Delivery Time',
    warehouse: 'Warehouse',
    estimated_cost: 'Estimated Cost',
    method: 'Method',
  },
  page_message: {
    title: 'Message',
    des: 'You need to pay attention to this part of the news, because we will send you a message or email.',
  },
  page_cart: {
    title: 'My Shopping Cart',
    item: 'Item',
    product: 'Product',
    price: 'Price',
    quantity: 'Quantity',
    freight: 'Freight',
    total: 'Total',
    info: 'Info',
    operate: 'Operate',
    pay_now: 'Submit',
    confirm_buy: 'Confirm to buy？',
    yes: 'Yes',
    no: 'No',
  },
  page_settlement: {
    title: 'Confirm Your Order',
    information: 'Note',
    note_line1: '1. Take photos of the product for free',
    note_line2: '2. The payment amount includes commodity cost, payment handling fee and service fee',
    note_line3: '3. We will inform you about the progress of the order by email. Please check in time',
    note_line4: '4. When your parcels arrive at warehouse you need to pay shipping cost',
    note_line5: '5. You need to pay extra fee for every payment(Paypal)',
    address_note: 'Please choose your destination country in order for our Shopping Agent to distinguish whether the item can be delivered or not.',
    submit_order: 'Create Order Now',
    confirm_submit: 'Confirm to submit？',
  },
  page_shopping_payment: {
    title: 'First Payment For Products',
    des: "Notice: This page can only pay for products. Shipping costs are paid on the #Int'l Parcels#  page.",
    total: 'Total',
    order_no: 'Order',
    pay_now: 'Go To Pay',
    shopping_notice: 'Important Notice:',
  },
  page_person: {
    account: 'Account',
    user_center: 'User Center',
    wallet: 'Wallet',
    orders: 'Orders',
    my_order: 'My Order',
    my_warehouse: 'In Warehouse',
    my_parcel: "Int'l Parcels",
    address_book: 'Address Book',
    online_store: 'Online Store',
    my_store: 'My Store',
    activity: 'Activity',
    invite: 'Invite',
    coupons: 'Coupons',
  },
  page_seller: {
    title: 'Trusted Seller',
    buy_hanfu_title: 'Buy Chinese Hanfu from these sellers, then we ship your parcel to you',
    buy_sneaker_title: 'Buy Sneaker from these sellers, then we ship your parcel to you',
    buy_cosplay_title: 'Buy Cosplay from these sellers, then we ship your parcel to you',
    step_line1: '1. Find products from these sellers',
    step_line2: '2. Submit shopping order',
    step_line3: '3. Ship to you',
  },
  page_profile: {
    account: 'Account',
    email: 'Email',
    balance: 'Balance',
  },
  page_wallet: {
    top_up: 'Top Up',
    underpaid: 'Underpaid',
    balance_details: 'Balance Details',
    time: 'Time',
    empty: 'Empty Record',
    amount: 'Amount',
    status: 'Status',
    info: 'Info',
    pay: 'Pay',
    paid: 'Paid',
    confirm: 'Confirm',
    discount_info: 'Discount Info',
    and_get: 'and get',
    get_extra: 'extra',
  },
  page_my_order: {
    product_pic: 'Product Pic',
    product_qc: 'QC Pic',
    store_order_no: 'Store Order No',
    type: 'Type',
    details: 'View',
    remark: 'Remark',
    process: 'Process',
    cn_track: 'CN Track',
    pay_order: 'Pay Order',
    search: 'Search',
  },
  page_order_detail: {
    title: 'Order Detail',
  },
  my_warehouse: {
    submit_to_ship: 'Ship My Products',
    actual_weight: 'Actual Weight',
    add_address: 'Add Address',
    select_method: 'Select Method',
    pay_order: 'Pay Order',
    consignee_name: 'Full Name',
    country_code: 'Country/Region',
    consignee_province: 'State/Province',
    consignee_city: 'City/Town',
    consignee_address_detail: 'Address',
    consignee_postcode: 'ZIP code',
    consignee_phone: 'Your Phone',
    consignee_email: 'Your Email',
    next: 'Next',
    shipping_cost: 'Shipping Cost',
    method_note: 'We will create a shipping payment after we pack all your products in 24 hours. Please pay attention to our email.',
    submit_order: 'Create Order',
    parcel_remark: 'Parcel Remark - Ask us to customize your parcel',
    such_as_parcel: '(Such as: Remove boxes)',
  },
  page_my_parcel: {
    delivery_number: 'Parcel Id',
    pay_shipping: 'Pay Shipping',
    address: 'Address',
    tracking: 'Tracking',
  },
  page_parcel_detail: {
    title: 'My Parcel',
    coupon_code: 'Coupon Code',
    user_remark: 'Parcel Remark',
    tracking_info: 'Tracking Info',
  },
  page_customer_review: {
    des: 'Share our services everywhere',
    submit_link: 'Submit Review Link',
  },
  page_dropshipping: {
    des: 'Make your business more successful',
  },
  page_invite: {
    your_share_link: 'Your Share Link',
    invitation_service: 'Invitation Service - You will get more',
    invitation_analysis: 'Invitation Analysis',
    get_cash_benefits: 'Get cash benefits - 0.5USD for one Invite User',
    cheap_cost: 'Get cheaper shipping cost',
    find_product: 'Find cheap products for you freely',
    invitation_users: 'Invitation Users',
    invitation_amount: 'Invitation Order Amount',
  },
  page_coupon: {
    available: 'Available Coupon',
    used: 'Coupon Used',
    expired: 'Coupon Expired',
  },
  page_taxation: {
    title: 'Compensation and Taxation',
    disclaimer: 'Disclaimer',
    d_line1: '1. No compensation will be given for the lost of mail due to force majeure such as natural disasters or customs reasons',
    d_line2: '2. If the delivered items violate the prohibition or restriction regulations, the competent authority will confiscate them or deal with them in accordance with relevant laws and regulations, and no compensation will be given',
    d_line3: '3. No compensation will be given for the lost of the mail or the shortage of the contents due to the responsibility of the customer or the reasons for the sent item itself',
    d_line4: '4. If the international mail is detained, confiscated or destroyed by the destination country according to its domestic laws, no compensation will be given',
    d_line5: '5. The user is responsible for the package that involves paying the tax',
    d_line6: '6. No freight compensation for customs reasons',
    d_line7: '7. Other than the above, compensation actual freight, and the maximum compensation is 400 RMB',
  },
  meta: {
    index_title: 'Taobao Agent | Tmall Agent | 1688 Agent | Taobao English | Shopping Agent | China Forwarder',
    index_des: 'We are a Chinese shopping agent platform.Help customers buy goods from taobao.Buying your favorite items from China has never been more convenient and easier.',
    shopping_agent_title: 'Shopping Agent',
    shopping_agent_des: 'Buy China products with shopping agent. Taobao agent, 1688 agent, Weidian agent, Yupoo agent.',
    forwarding_title: 'Forwarding Agent - Ship your parcel from China',
    forwarding_des: 'Professional global transshipment platform, with transshipment warehouses and providing professional logistics services to the United States, the United Kingdom, Canada, Germany, Australia, Singapore, Mexico and other countries, transshipment worldwide',
    expert_buy_title: 'Expert Buy',
    expert_buy_des: 'Buy products from Taobao Agent, Import from China. Lowest shipping prices. No service fee.',
    calculator_title: 'International logistics freight estimate',
    calculator_des: 'Help you estimate global logistics costs. Affordable logistics service. Faster logistics service.',
    trusted_seller_title: 'Trusted Seller',
    trusted_seller_des: 'Trusted Seller: Shop from these sellers, then we ship to you. Taobao sellers, Weidian sellers.',
  },
  my_parcel: {
    "internationalParcels": "International Parcels",
    "trackYourInternationalShipments": "Track your international shipments and configure shipping preferences",
    "pleaseSelect": "Please select",
    "yourRemark": "Your Remark",
    "startDate": "Start Date",
    "endDate": "End Date",
    "alertTrackParcels": "Track your parcels here. Parcels with status 'Ready for Shipping Config' have been packaged and measured, and are ready for you to configure shipping.",
    "noPackagesToShip": "You don't have any packages to ship",
    "parcel": "Parcel",
    "insurance": "Add Insurance",
    "insuranceHint": `Niuniubox Service
Upon purchasing Niuniubox insurance, you are eligible for compensation in the following situations:Lost
lf your insured parcel is lost we will provide compensation based on the actual situation. The maximum compensation amount is 5000 CNY fort he goods and 3,000 CNY for shipping fees. Compensation for lost items can be claimed after reaching the standard time-frame. For compensation standards, please refer to the Niuniubox insurance policy.
Customs Seizure
If your insured parcel is confirmed to have been seized by Customs, Niuniubox will provide compensation based on the actual situation. The maximum compensation amount is 5000 CNY for the goods and 3000 CNY for shipping fees.
Compensation for Customs detention can be seized after the standard time-frame has passed. For compensation standards, please refer to the Niuniubox insurance policy.`,
    "insuranceTotal": "Total Insurance Fee",
    "parcelID": "Parcel ID:",
    "shippingLabel": "Shipping Cost:",
    "pending": "pending",
    "finalFee": "Final Fee:",
    "discount": "Discount:",
    "coupon": "Coupon:",
    "created": "Created:",
    "status": "Status",
    "shippingMethod": "Shipping Method",
    "notConfiguredYet": "Not configured yet",
    "products": "product(s)",
    "measured": "Measured",
    "estimated": "Estimated",
    "dimensions": "Dimensions:",
    "weightInformation": "Weight Information",
    "billingWeight": "Billing Weight:",
    "na": "N/A",
    "actual": "Actual:",
    "volume": "Volume:",
    "action": "Action",
    "configureShippingMethod": "Shipping Method",
    "payShipping": "Pay Shipping",
    "track": "Track",
    "address": "Address",
    "shipping": "Shipping:",
    "configure": "Configure",
    "pay": "Pay",
    "viewMoreProducts": "View More Products in This Parcel",
    "orderID": "Order ID:",
    "quantity": "Quantity:",
    "times": "x",
    "addressLabel": "Address",
    "yourRemarkTitle": "Your Remark",
    "parcelRemarkTitle": "Parcel Remark",
    "noRemarks": "No remarks for this parcel",
    "parcelImages": "Parcel Images",
    "failedToLoad": "Failed to load",
    "noImages": "No images available for this parcel",
    "productsInParcel": "Products in Parcel",
    "type": "Type:",
    "noProducts": "No product details available for this parcel",
    "configureShipping": "Configure Shipping",
    "alertPackagePrepared": "Your package has been prepared. Now select your shipping method and provide your delivery address.",
    "packageDetails": "Package Details",
    "readyForShipping": "Ready for Shipping",
    "actualWeight": "Actual Weight:",
    "actualDimensions": "Actual Dimensions:",
    "packagingNotes": "Packaging Notes:",
    "step1SubmitAddress": "Step 1: Submit Address",
    "select": "Select",
    "recipientName": "Recipient Name",
    "email": "Email",
    "phoneNumber": "Phone Number",
    "country": "Country",
    "city": "City",
    "stateProvince": "State/Province",
    "zipCode": "ZIP Code",
    "selectShippingMethod": "Select Shipping Method",
    "selectCountryFirst": "Select Country First",
    "selectedShippingMethod": "Selected Shipping Method",
    "estimatedDelivery": "Estimated Delivery",
    "estimatedFee": "Estimated Fee:",
    "changeShippingMethod": "Change Shipping Method",
    "remark": "Remark",
    "shippingRemarkPlaceholder": "CPF / CNPJ / Tax Id / shipping remark",
    "saveAddress": "Save Address",
    "saveAddressHint": "Save this address to your address book for future use",
    "submitShippingConfiguration": "Submit Shipping Configuration",
    "parcelDetailsTitle": "Parcel Details",
    "statusSection": "Status",
    "actions": "Actions",
    "parcelDetails": "Parcel Details",
    "trackingInfo": "Tracking Info",
    "addressInfo": "Address Info",
    "costDetails": "Cost Details",
    "costPending": "pending",
    "shippingMethodNotConfigured": "Shipping method not configured yet",
    "packageDimensions": "Package Dimensions",
    "measuredDimensions": "Measured Dimensions",
    "estimatedDimensions": "Estimated Dimensions",
    "length": "Length:",
    "width": "Width:",
    "height": "Height:",
    "totalVolume": "Total Volume:",
    "volumetricWeight": "Volumetric Weight:",
    "weightCalculation": "Weight calculation",
    "weightCalcVolumeUsed": "Volume weight used (higher)",
    "weightCalcActualUsed": "Actual weight used (higher)",
    "billingWeightTooltip": "This is the weight used for billing (higher of actual vs volumetric)",
    "remarks": "Remarks",
    "noProducts": "No product details available for this parcel",
    delivery_number: "Parcel ID",
  },
  footer: {
    supportTitle: "Support",
    "support": [
      "About Us",
      "Contact Us",
      "Service Pricing",
      "Shipping Cost"
    ],
    servicesTitle: "Services",
    "services": [
      "Taobao Shopping",
      "Yupoo Agent",
      "Weidian Agent",
      "Product Sourcing"
    ],
    tutorialTitle: "Tutorial",
    "tutorial": [
      "Shopping Guide",
      "Our Blog",
      "Shipping Cost"
    ],
    resourcesTitle: "Resources",
    "resources": [
      "Shipping Policy",
      "Refund & Return",
      "Privacy Policy",
      "Terms of Service"
    ],
    followTitle: "Follow Us",
    "follow": [
      "Youtube",
      "TikTok",
      "Facebook",
      "Quora",
      "Twitter"
    ],
    "copyright": "© 2025 NiuNiuBox - Hong Kong Niuniubox Technology Co., Limited",
    "paymentMethods": [
      "PayPal",
      "American Express",
      "Discover",
      "JCB",
      "Mastercard",
      "VISA"
    ]
  },
  sidebar_titles: ["USER PROFILE", "ORDERS & SHIPPING", " FINANCE", "ACCOUNT"],
  sidebar: [
    "Account Info",
    "Shopping Order",
    "In Warehouse",
    "My Rehearsal",
    "My Parcels",
    "Address Book",
    "Cancel Order",
    "Order History",
    "My Balance",
    "Message",
    "My Coupon",
    "Account Setting",
    "Affiliation"
  ],
  navbar: {
    items: ["Shipping Estimate", "Affiliation", "Contact", "Guide"],
    cart: "Cart",
    login: "Login",
    register: "Register",
    logout: "Logout",
    no: "No",
    logout_confirm: "Are you sure you want to log out?",
    search: "Search",
    searchPlaceholder: "Product URL",
    dropdown: [
      "User Center",
      "Message",
      "Shopping Order",
      "In Warehouse",
      "My Rehearsal",
      "My Parcels",
      "Cancel Order",
      "Sign out"
    ],
    me: "Me",
    home: "Home",
    menu: "Menu",
    notice: "Notice",

  },
  "in_warehouse": {
    "packages_in_warehouse": "Packages In Warehouse",
    "product_name": "Product Name",
    "please_select": "Please select",
    "remark": "Remark",
    "style_sku": "Style/SKU",
    "start_date": "Start Date",
    "end_date": "End Date",
    "reset_selections": "Reset Selections",
    "select_products_alert": "Select products to package together. When packaged, you'll be notified and can select shipping options in 'My Parcels' page.",
    "estimated_weight": "Estimated Weight: {weight} KG",
    "rehearse_parcel": "Rehearse Parcel",
    "request_packaging": "Request Packaging",
    "orders_not_arrived_alert": "You have {count} orders that have not arrived at warehouse. Please confirm if you want to package now or wait for all items.",
    "table_empty_text": "Nothing in this page. You can check other pages.",
    "column_image": "Image",
    "column_details": "Details",
    "order_label": "Order:",
    "total_label": "Total:",
    "type_label": "Type:",
    "status_label": "Status:",
    "time_label": "Time:",
    "style_label": "Style:",
    "quantity_prefix": "x",
    "no_remark": "No remark",
    "package_info_label": "Package Info",
    "weight_label": "Weight:",
    "length_label": "Length:",
    "width_label": "Width:",
    "height_label": "Height:",
    "unit_kg": "KG",
    "unit_cm": "CM",
    "action_label": "Action",
    "view": "View",
    "photos": "Photos",
    "cancel": "Cancel",
    "mobile_label_total": "Total:",
    "mobile_label_type": "Type:",
    "mobile_label_name": "Name:",
    "view_product": "View Product",
    "mobile_style_label": "Style:",
    "no_items_selected": "No items selected",
    "submit_packaging_request": "Submit Packaging Request",
    "dialog_request_packaging_title": "Request Packaging",
    "dialog_request_packaging_info": "We will package your selected items together. Once packaged, you'll be able to view the actual dimensions and select shipping options in 'My Parcels'.",
    "packaging_instructions": "Packaging Instructions",
    "placeholder_packaging_instructions": "Any special packaging instructions or concerns?",
    "selected_items": "Selected Items",
    "packaging_note": "Note: After packaging, we'll determine the exact dimensions and weight of your parcel. You'll then be able to choose your shipping method and provide your address in the 'My Parcels' section.",
    "new_packaging_process": "New Packaging Process",
    "step_request_packaging": "Request Packaging:",
    "step_request_packaging_desc": "Select products and submit packaging request.",
    "step_warehouse_packaging": "Warehouse Packaging:",
    "step_warehouse_packaging_desc": "Our staff will package your selected items.",
    "step_measurement": "Measurement:",
    "step_measurement_desc": "We'll measure the exact dimensions and weight of your package.",
    "step_notification": "Notification:",
    "step_notification_desc": "You'll be notified when your package is ready.",
    "step_shipping_setup": "Shipping Setup:",
    "step_shipping_setup_desc": "Go to \"My Parcels\" to select shipping options and enter your address.",
    "step_make_payment": "Make Payment:",
    "step_make_payment_desc": "Pay for shipping based on actual package dimensions and weight.",
    "confirm_packaging_title": "Confirm Packaging Request",
    "confirm_packaging_text": "You are about to request packaging for {count} item(s). Continue?",
    "item_qc_photos": "Item QC Photos",
    "empty_qc_desc": "Your item has not arrived at our warehouse.",
    "return_items_title": "Return Items",
    "return_items_text": "Returning items may incur additional costs. Do you still want to proceed?",
    "number_of_items_to_return": "Number of items to return:",
    "confirm": "Confirm",
    column_image: "Image",
  },
  account: {

  },
  "page_order_history": {
    "title": "Order History",
    "search": {
      "order_number_placeholder": "Order Number",
      "product_name_placeholder": "Product Name",
      "remark_placeholder": "Remark",
      "style_sku_placeholder": "Style/SKU",
      "start_date_placeholder": "Start Date",
      "end_date_placeholder": "End Date",
      "status_placeholder": "Please select"
    },
    "buttons": {
      "search": "Search",
      "pay_shopping_orders": "Pay Shopping Orders",
      "pay_order": "Pay Order",
      "view_order": "View Order",
      "item_photos": "Item Photos",
      "view_product": "View Product"
    },
    "table": {
      "empty_text": "You don't have any shopping orders yet",
      "header": {
        "image": "Image",
        "details": "Details",
        "product": "Product",
        "action": "Action"
      },
      "body": {
        "order": "Order:",
        "total": "Total:",
        "type": "Type:",
        "status": "Status:",
        "time": "Time:",
        "style": "Style:",
        "quantity": "Quantity:",
        "remark": "Remark:",
        "name": "Name:"
      }
    },
    "qc_dialog": {
      "title": "Item QC Photos",
      "notice": "Starting from August, we will no longer provide QC photo services.",
      "empty_description": "Your item has not arrived at our warehouse."
    }
  },
  "page_address_book": {
    "title": "My Address Book",
    "buttons": {
      "add_new": "Add New",
      "save": "Save Address"
    },
    "dialog": {
      "title": "Add Your Address",
      "alert": "Add your address and it can be used next time!",
      "form": {
        "contact_name": "Contact Name",
        "address": "Address",
        "city": "City",
        "province": "State/Province",
        "country": "Country",
        "country_placeholder": "Select Destination Country",
        "zip_code": "Zip code",
        "phone": "Phone",
        "email": "Email",
        "email_placeholder": "Recommended"
      }
    }
  },
  "page_wallet": {
    "header": {
      "title": "Wallet Overview",
      "subtitle": "Manage your balance and transaction history"
    },
    "balance_card": {
      "label": "Available Balance",
      "currency": "USD",
      "top_up_button": "Top Up Balance"
    },
    "history": {
      "title": "Transaction History",
      "count": "{count} transactions",
      "empty": {
        "title": "No transactions yet",
        "subtitle": "Your transaction history will appear here"
      },
      "item": {
        "order_prefix": "Order:",
        "balance_after_prefix": "Balance:",
        "note_prefix": "Note:",
        "complete_payment_button": "Complete Payment",
        "mobile": {
          "order_id_label": "Order ID:",
          "balance_after_label": "Balance After:",
          "status_label": "Status:"
        }
      }
    },
    "top_up_dialog": {
      "title": "Top Up",
      "form": {
        "amount_label": "Enter Amount (USD)",
        "quick_select_title": "Quick Select Amount",
        "create_payment_button": "Create Payment"
      }
    }
  },
  "page_message_center": {
    "title": "Message Center",
    "filters": {
      "all": "All",
      "unread": "Unread",
      "read": "Read",
      "search_placeholder": "Search messages..."
    },
    "actions": {
      "mark_all_read": "Mark all as read",
      "delete_all": "Delete all messages",
      "refresh": "Refresh Messages"
    },
    "delete_confirm": {
      "title": "Delete this message?",
      "confirm_button": "Delete",
      "cancel_button": "Cancel"
    },
    "empty_states": {
      "no_search_results": "No messages found matching your search.",
      "no_unread": "You have no unread messages.",
      "no_read": "You have no read messages.",
      "no_messages_yet": "Your message center is empty."
    }
  },
  "page_user_profile": {
    "tabs": {
      "profile": "Profile",
      "account_safety": "Account Safety"
    },
    "profile_section": {
      "email": "E-mail:",
      "gender": "Gender:",
      "country": "Country:",
      "language": "Language:",
      "current_language": "English",
      "phone": "Phone:",
      "birthday": "Birthday:",
      "vip_prefix": "VIP",
      "max_vip_level": "VIP5",
      "privilege_title": "My Privilege",
      "privilege_table_header": "Level Privilege"
    },
    "safety_section": {
      "modify_password_title": "Modify Password",
      "modify_password_desc": "A higher-leveled password makes your account safer. It is recommended to change your password regularly containing numbers and letters.",
      "modify_password_button": "Modify Password"
    },
    "update_info_dialog": {
      "title": "Update Account Info",
      "account_name_label": "Account Name",
      "phone_label": "Phone Number",
      "gender_label": "Gender",
      "gender_placeholder": "Select",
      "country_label": "Country",
      "country_placeholder": "Select country",
      "birthday_label": "Birthday",
      "birthday_placeholder": "Select",
      "save_button": "Save Info"
    },
    "update_password_dialog": {
      "title": "Update Password",
      "old_password_label": "Old Password",
      "new_password_label": "New Password",
      "confirm_password_label": "Confirm Password",
      "save_button": "Save"
    }
  },
  "page_shipping_calculator": {
    "hero": {
      "title": "Your Ultimate Chinese Shopping Agent"
    },
    "form_card": {
      "title": "Shipping Fee Estimation",
      "subtitle": "Enter your package details below to get precise shipping costs",
      "country_label": "Destination Country",
      "country_placeholder": "Select Country",
      "country_search_placeholder": "Search for a country...",
      "no_countries_for_letter": "No countries starting with {letter}.",
      "no_countries_for_search": "No countries found for \"{query}\".",
      "category_label": "Product Category",
      "category_placeholder": "Select Category",
      "select_main_category_first": "Select a main category first.",
      "weight_label": "Weight (kg)",
      "length_label": "Length (cm)",
      "width_label": "Width (cm)",
      "height_label": "Height (cm)",
      "required_label": "Required",
      "optional_label": "(Optional)",
      "optional_placeholder": "Optional",
      "calculating_button": "Calculating...",
      "submit_button": "Get Shipping Fee"
    },
    "summary": {
      "title": "Shipping Query Summary",
      "sort_by": "Sort by:",
      "sort_price": "Price",
      "sort_time": "Transit Time",
      "destination": "Destination:",
      "weight": "Weight:",
      "dimensions": "Dimensions:",
      "volume": "Volume:",
      "categories": "Categories:"
    },
    "results": {
      "loading_text": "Calculating available shipping options...",
      "no_options_title": "No Shipping Options Available",
      "no_options_desc": "No valid shipping options found for the entered details and destination. <br /> Please check weight, dimensions, and product category restrictions for the selected country.",
      "initial_state_text": "Please enter the required parameters (Country, Weight) and click \"Get Shipping Fee\".",
      "all_unavailable_info": "All shipping channels for this combination are unavailable. See details below.",
      "est_transit_time": "Est. Transit Time",
      "volume_weight": "Volume Weight",
      "billing_weight": "Billing Weight",
      "view_details_button": "View Details",
      "load_more_button": "Load More ({count} remaining)",
      "unavailable_channels_title": "Unavailable Shipping Channels ({count})",
      "not_available_badge": "Not Available",
      "reason_prefix": "Reason:"
    },
    "details_modal": {
      "overview_title": "Shipping Overview",
      "shipping_fee": "Shipping Fee",
      "description_title": "Service Description",
      "no_description": "No description available.",
      "restrictions_title": "Transport Restrictions",
      "category_restrictions_title": "Product Category Restrictions",
      "legend_can_send": "Can Send",
      "legend_cannot_send": "Cannot Send",
      "can_send_subheading": "Can Send:",
      "cannot_send_subheading": "Cannot Send:",
      "no_allowed_items": "No specific allowed items listed (assumes general goods okay unless restricted)",
      "no_prohibited_items": "No specific prohibited items listed (standard carrier prohibitions apply)",
      "rules_title": "Transportation Rules",
      "weight_restriction_title": "Weight Restriction",
      "dimension_restriction_title": "Dimension Restriction",
      "billing_rules_title": "Billing Rules",
      "tax_info_title": "Tax Info",
      "additional_fees_title": "Additional Fees",
      "no_additional_fees": "None specified (standard carrier fees may apply)",
      "min_label": "Min:",
      "max_label": "Max:",
      "carrier_limit": "Carrier Limit",
      "close_button": "Close"
    }
  },
  "page_shopping_guide": {
    "header": {
      "title": "Shopping Guide",
      "description": "Guide To Buy From Taobao, 1688, Weidian and Yupoo For Beginners",
      "video_title": "Shopping Process Video"
    },
    "process": {
      "title": "Shopping Process",
      "step1": {
        "title": "Step 1: Select Product",
        "description": "Find the product you want on Taobao.com, 1688.com, Tmall.com, or Weidian."
      },
      "step2": {
        "title": "Step 2: Search Product",
        "description": "If you cannot find the product you desire, feel free to ask our 24/7 customer service for assistance. Copy and paste the product link into the NiuNiuBox site. If you are using the Taobao app, you can also find the product link on the Taobao Product Detail Page."
      },
      "step3": {
        "title": "Step 3: Select Size/Color",
        "description": "Confirm the size and color of the product you need on NiuNiuBox, then add it to your shopping cart."
      },
      "step4": {
        "title": "Step 4: First Payment",
        "description": "View your shopping cart and complete the first payment for your selected items."
      },
      "step5": {
        "title": "Step 5: Submit Your Address",
        "description": "Once you've completed the first payment, the NiuNiuBox team will purchase the products for you. After all your products arrive at our warehouse, you will need to submit your address so that we can pack your items into one large box."
      },
      "step6": {
        "title": "Step 6: Second Payment",
        "description": "After we have packed your products, you will receive an email with the package weight and shipping cost. You will then need to pay the international shipping cost, and we will ship your package from our China warehouse to your address."
      },
      "step7": {
        "title": "Step 7: Waiting for Your Package",
        "description": "After your package has been shipped, you will receive a tracking number within 3 days. This will allow you to see the location of your package."
      }
    }
  },
  "page_contact_us": {
    "title": "Contact Us",
    "support_email_label": "Customer Support Email:"
  },
  "page_my_account": {
    "title": "My Account",
    "profile_card": {
      "member_type": "Ordinary member",
      "member_since": "Member since",
      "logout_confirm": "Are you sure you want to sign out?",
      "top_up_button": "Top Up",
      "orders_label": "Orders",
      "coupons_label": "Coupons"
    },
    "balance_info": {
      "title": "About Your Balance",
      "description": "When you request to cancel an order, your remaining funds will automatically be transferred to your balance.",
      "highlight1": "Continue shopping with your balance",
      "highlight2": "Contact customer service for refunds to your payment account"
    },
    "quick_actions": {
      "title": "Quick Actions",
      "shopping_orders": "Shopping Orders",
      "in_warehouse": "In Warehouse",
      "my_rehearsal": "My Rehearsal",
      "my_parcels": "My Parcels",
      "my_balance": "My Balance",
      "messages": "Messages",
      "my_coupons": "My Coupons",
      "cancel_order": "Cancel Order"
    },
    "recent_orders": {
      "title": "Recent Orders",
      "view_all_button": "View All",
      "header_product": "Product",
      "header_amount": "Amount",
      "header_date": "Date",
      "header_status": "Status",
      "header_actions": "Actions",
      "quantity_prefix": "Qty:",
      "details_button": "Details"
    },
    "invitation": {
      "title": "Invite Friends",
      "description": "Share our site with friends and earn rewards:",
      "copy_button": "Copy"
    }
  },
  "page_shopping_order": {
    "title": "Shopping Order",
    "search": {
      "order_number_placeholder": "Order Number",
      "product_name_placeholder": "Product Name",
      "status_placeholder": "Please select",
      "remark_placeholder": "Remark",
      "style_sku_placeholder": "Style/SKU",
      "start_date_placeholder": "Start Date",
      "end_date_placeholder": "End Date",
      "search_button": "Search",
      "pay_button": "Pay Shopping Orders"
    },
    "info_alert": "This page displays shopping orders like Taobao/1688/Weidian orders. Please Select [Payment Pending] Orders and Pay.",
    "table": {
      "empty_text": "You don't have any shopping orders yet",
      "header": {
        "image": "Image",
        "details": "Details",
        "product": "Product",
        "action": "Action"
      },
      "body": {
        "order_prefix": "Order:",
        "total_prefix": "Total:",
        "type_prefix": "Type:",
        "status_prefix": "Status:",
        "time_prefix": "Time:",
        "style_prefix": "Style:",
        "quantity_prefix": "Quantity:",
        "remark_prefix": "Remark:",
        "name_prefix": "Name:"
      },
      "actions": {
        "pay_order": "Pay Order",
        "view_order": "View Order",
        "item_photos": "Item Photos",
        "cancel_item": "Cancel Item",
        "view_product": "View Product"
      }
    },
    "qc_dialog": {
      "title": "Item QC Photos",
      "empty_text": "Your item has not arrived at our warehouse."
    },
    "return_dialog": {
      "title": "Return Items",
      "confirmation_text": "Returning items may incur additional costs. Do you still want to proceed?",
      "quantity_label": "Number of items to return:",
      "cancel_button": "Cancel",
      "confirm_button": "Confirm"
    },
    "cancel_dialog": {
      "title": "Cancel Order",
      "confirmation_text": "If you want to cancel this order, you need to pay the shipping fee. The fee will be deducted from your payment already made. Do you want to proceed?",
      "cancel_button": "Cancel",
      "confirm_button": "Confirm"
    }
  },
   "page_shipping_config": {
    "title": "Shipping Config",
    "summary": {
      "destination": "Destination:",
      "actual_weight": "Actual Parcel Weight:",
      "est_dimensions": "Estimated Dimensions:",
      "weight_note": "*Estimated package weight based on product weight, and the actual weight will be determined after weighing.",
      "product_types": "Product Types",
      "selected_method": "Shipping Method Selected:",
      "selected_method_none": "None",
      "est_fee": "Estimated Fee:"
    },
    "status": {
      "loading": "Calculating available shipping options...",
      "no_options": "No shipping options are available for the current package weight, dimensions, product types and country. <br />Please review the restrictions."
    },
    "options": {
      "select_sr_label": "Select {channelName}",
      "shipping_fee": "Shipping Fee",
      "volume_weight": "Volume Weight",
      "volume_weight_formula": "Volume Weight (KG) = L*W*H (CM) / {denominator}",
      "billing_weight": "Billing Weight",
      "billing_weight_details": "Based on the greater of the actual weight ({weight} kg) and volume weight. Rounding and minimums may apply per channel rules.",
      "transit_time": "Transit Time",
      "hide_details_button": "Hide Details",
      "show_details_button": "Show Detail"
    },
    "details": {
      "category_restrictions_title": "Product Category Restrictions",
      "legend_can_send": "Can Send",
      "legend_cannot_send": "Cannot Send",
      "can_send_subheading": "Can Send:",
      "no_allowed_items": "No specific allowed items listed (assumes general goods okay unless restricted)",
      "cannot_send_subheading": "Cannot Send:",
      "no_prohibited_items": "No specific prohibited items listed (standard carrier prohibitions apply)",
      "rules_title": "Transportation Rules",
      "weight_restriction_title": "Weight Restriction",
      "min_label": "Min:",
      "max_label": "Max:",
      "carrier_limit": "Carrier Limit",
      "dimension_restriction_title": "Dimension Restriction",
      "billing_rules_title": "Billing Rules",
      "tax_info_title": "Tax Info",
      "additional_fees_title": "Additional Fees",
      "no_additional_fees": "None specified (standard carrier fees may apply)"
    },
    "confirm_button": "Confirm"
  },
  "page_parcel_details": {
    "loading": "Loading parcel details...",
    "overview": {
      "title": "Parcel Overview",
      "parcel_id": "Parcel ID",
      "payment_time": "Payment Time",
      "status": "Status",
      "shipping_cost": "Shipping Cost",
      "billing_weight": "Billing Weight",
      "parcel_remark": "Parcel Remark",
      "your_note": "Your Note"
    },
    "tracking": {
      "title": "Tracking Information",
      "empty_text": "No tracking info yet. You will receive a tracking number once shipped (~3 days)."
    },
    "items": {
      "title": "Product Items",
      "empty_text": "No items found",
      "header_order_image": "Order / Image",
      "header_product_details": "Product Details",
      "header_qc_photos": "QC Photos",
      "order_prefix": "Order:",
      "sku_prefix": "SKU:",
      "quantity_prefix": "Qty:",
      "note_prefix": "Note:"
    }
  },
  "page_parcel_details": {
    "loading": "Loading parcel details...",
    "overview": {
      "title": "Parcel Overview",
      "parcel_id": "Parcel ID",
      "payment_time": "Payment Time",
      "status": "Status",
      "shipping_cost": "Shipping Cost",
      "billing_weight": "Billing Weight",
      "parcel_remark": "Parcel Remark",
      "your_note": "Your Note"
    },
    "tracking": {
      "title": "Tracking Information",
      "empty_text": "No tracking info yet. You will receive a tracking number once shipped (~3 days)."
    },
    "items": {
      "title": "Product Items",
      "empty_text": "No items found",
      "header_order_image": "Order / Image",
      "header_product_details": "Product Details",
      "header_qc_photos": "QC Photos",
      "order_prefix": "Order:",
      "sku_prefix": "SKU:",
      "quantity_prefix": "Qty:",
      "note_prefix": "Note:"
    }
  },
  "page_affiliate": {
    "header": {
      "title": "30% Bonus Boost",
      "description": "Based on Bonus of New Affiliation's Shipment"
    },
    "commission": {
      "title": "My Promotion Commission",
      "invited_users": "Invited Users:",
      "new_affiliates": "New Affiliates:",
      "active_users": "Active Users:"
    },
    "balance": {
      "title": "My affiliate balance",
      "amount_withdrawn": "Amount Withdrawn:",
      "withdrawn_button": "Withdrawn",
      "withdrawable_title": "Withdrawable",
      "board_earnings_title": "Board Creating Earnings",
      "claim_button": "Claim"
    },
    "steps": {
      "step1": "Share invitation codes with your friends",
      "step2": "A friend placed an order and received the package",
      "step3": "Get the commission"
    },
    "promotion_method": {
      "title": "Promotion Method",
      "mobile_description": "Rule Description Rule Description Rule Description Rule Description Rule Description",
      "desktop_description": "The commission you receive every month will be directly transferred to your personal account.",
      "invite_link_label": "Invite Link:",
      "copy_link_button": "Copy Link",
      "copy_code_button": "Copy Invitation Code",
      "download_qr_button": "Download QR Code"
    }
  },
  "page_product_details": {
    "promo_banner": "Buy cost-effective products from Chinese e-commerce websites and save more money. Worldwide shipping from China.",
    "stats": {
      "sales": "Sales:",
      "inventory": "Inventory:"
    },
    "info": {
      "original_link": "Original Link",
      "processing_time": "After payment, we will buy for you within 12 hours.",
      "domestic_shipping": "Domestic Shipping",
      "free_shipping": "Free Shipping",
      "shipping_note": "The local shipping cost from the seller to our China warehouse."
    },
    "options": {
      "quantity": "Quantity",
      "items_available": "{count} items available",
      "order_remark": "Order Remark:",
      "order_remark_subtitle": "Add any special instructions or requests",
      "remark_placeholder": "Please leave a message to the seller, such as color, size, etc."
    },
    "actions": {
      "shipping_cost_estimate": "Shipping Cost Estimate",
      "disclaimer_title": "Disclaimer",
      "disclaimer_text": "All Products Available For Shopping Agent Service Displayed On Niuniubox Are From Third-Party Shopping Platforms And Not Directly Sold By Niuniubox. Thus, Niuniubox Does Not Take Liability And Legal Responsibility For Issues Caused By Intellectual Property Rights Infringement And Goods Copyright Infringement.",
      "agreement_checkbox": "I have read and agreed",
      "buy_now": "Buy Now",
      "add_to_cart": "Add to Cart",
      "share": "Share"
    },
    "share_dialog": {
      "title": "Share this product",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "WeChat",
      "platform_discord": "Discord",
      "platform_email": "Email",
      "copy_button": "Copy"
    },
    "sidebar": {
      "original_site": "Original site:",
      "why_title": "Why Taobao, 1688, Weidian, Yupoo, Tmall?",
      "why_description": "The products on these platforms are very cheap. If you need to spend the least amount of money to buy high-quality products, buying from these platforms is the most cost-effective. We provide global logistics services by air line and sea line.",
      "details_title": "Product Details",
      "empty_details": "Empty Product Detail."
    },
    "loading": {
      "try_again": "Try Again",
      "note_title": "Note:",
      "error_note_1": "1. You can contact us if you can not see the product information.",
      "error_note_2": "2. The product is out of stock or the product url is invalid. Please double check your product link.",
      "error_note_3": "3. Platform Support: Taobao.com, 1688.com, Tmall.com, Weidian.com (Only support product url)"
    }
  },
  "page_product_details": {
    "promo_banner": "Buy cost-effective products from Chinese e-commerce websites and save more money. Worldwide shipping from China.",
    "stats": {
      "sales": "Sales:",
      "inventory": "Inventory:"
    },
    "info": {
      "original_link": "Original Link",
      "processing_time": "After payment, we will buy for you within 12 hours.",
      "domestic_shipping": "Domestic Shipping",
      "free_shipping": "Free Shipping",
      "shipping_note": "The local shipping cost from the seller to our China warehouse."
    },
    "options": {
      "quantity": "Quantity",
      "items_available": "{count} items available",
      "order_remark": "Order Remark:",
      "order_remark_subtitle": "Add any special instructions or requests",
      "remark_placeholder": "Please leave a message to the seller, such as color, size, etc."
    },
    "actions": {
      "shipping_cost_estimate": "Shipping Cost Estimate",
      "disclaimer_title": "Disclaimer",
      "disclaimer_text": "All Products Available For Shopping Agent Service Displayed On Niuniubox Are From Third-Party Shopping Platforms And Not Directly Sold By Niuniubox. Thus, Niuniubox Does Not Take Liability And Legal Responsibility For Issues Caused By Intellectual Property Rights Infringement And Goods Copyright Infringement.",
      "agreement_checkbox": "I have read and agreed",
      "buy_now": "Buy Now",
      "add_to_cart": "Add to Cart",
      "share": "Share"
    },
    "share_dialog": {
      "title": "Share this product",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "WeChat",
      "platform_discord": "Discord",
      "platform_email": "Email",
      "copy_button": "Copy"
    },
    "sidebar": {
      "original_site": "Original site:",
      "why_title": "Why Taobao, 1688, Weidian, Yupoo, Tmall?",
      "why_description": "The products on these platforms are very cheap. If you need to spend the least amount of money to buy high-quality products, buying from these platforms is the most cost-effective. We provide global logistics services by air line and sea line.",
      "details_title": "Product Details",
      "empty_details": "Empty Product Detail."
    },
    "loading": {
      "try_again": "Try Again",
      "note_title": "Note:",
      "error_note_1": "1. You can contact us if you can not see the product information.",
      "error_note_2": "2. The product is out of stock or the product url is invalid. Please double check your product link.",
      "error_note_3": "3. Platform Support: Taobao.com, 1688.com, Tmall.com, Weidian.com (Only support product url)"
    }
  },
  "shopping_steps": {
    "title": "How It Works",
    "steps_data": [
      {
        "title": "Find Products",
        "des": "Browse millions of products from Chinese marketplaces like Taobao, 1688, Weidian, Tmall at wholesale prices"
      },
      {
        "title": "Add to Cart",
        "des": "Select your items, choose specifications, and add them to your cart for easy order management"
      },
      {
        "title": "Make Payment",
        "des": "Pay securely for your items, and we will purchase them from different sellers on your behalf"
      },
      {
        "title": "Receive Delivery",
        "des": "We ship your consolidated package from China to your doorstep with complete tracking information"
      }
    ]
  }




}
